<template>
  <b-button
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    :variant="`flat-${variant}`"
    class="btn-icon rounded-circle"
    v-b-tooltip.hover.top="{ title: $t(i18nHoverVariable), variant }"
    @click="$emit('clicked')"
  >
    <feather-icon icon="SlashIcon" />
  </b-button>
</template>

<script >
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'SlashButton',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    variant: {
      type: String,
      default: "warning",
    },
    i18nHoverVariable: {
      type: String,
      default: "message.finish",
    },
  },
}
</script>

<style scoped>

</style>
